import moment from 'moment/moment';
import { analytics } from '@/services/segment/segment';

// noinspection JSIgnoredPromiseFromCall
class AnalyticsService {
  constructor(app) {
    this.app = app;
  }
  /**
   * @param {string} eventName
   * @param {{}} properties
   */
  segmentTrack(eventName, properties = {}) {
    analytics.track(eventName, {
      page: this.app.$route.meta.nameForAnalytics,
      ...properties,
    });
  }
  /**
   * @param {string} pageName
   * @param {{}} properties
   */
  segmentPage(pageName, properties = {}) {
    analytics.page(pageName, properties);
  }

  /**
   * @param {string} dateTime
   * @param {string} format
   * @return {string}
   */
  getDateTimeIsoFormat(dateTime, format) {
    return moment.utc(dateTime, format).toISOString();
  }

  getOs() {
    const agent = window.navigator.userAgent;
    if (/Windows/i.test(agent)) {
      return /Phone/.test(agent) || /WPDesktop/.test(agent)
        ? 'Windows Phone'
        : 'Windows';
    }
    if (/(iPhone|iPad|iPod)/.test(agent)) {
      return 'iOS';
    }
    if (/Android/.test(agent)) {
      return 'Android';
    }
    if (/(BlackBerry|PlayBook|BB10)/i.test(agent)) {
      return 'BlackBerry';
    }
    if (/Mac/i.test(agent)) {
      return 'Mac OS X';
    }
    if (/Linux/.test(agent)) {
      return 'Linux';
    }
    if (/CrOS/.test(agent)) {
      return 'Chrome OS';
    }
    return '';
  }
}

export const analyticsService = new AnalyticsService();
